import { Component, OnDestroy, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import { BureauService } from './core/services/bureau.service'
import { OperadorService } from './core/services/operador.service'
import { menuUtils } from './menu/menu.utils'
import RouterUtils from './menu/router.utils'
import { Operador } from './pkw-data/core/operador.model'
import { Bureau } from './pkw-data/core/bureau.model'

@Component({
    selector: 'col-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    routerUtils: RouterUtils

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private operadorService: OperadorService,
        private bureauService: BureauService
    ) {}

    ngOnInit() {
        this.inicializarMenu()
        this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map((route) => {
                while (route.firstChild) {
                    route = route.firstChild
                }
                return route
            })
            .filter((route) => route.outlet === 'primary')
            .mergeMap((route) => route.data)
            .subscribe((routeData) => {
                if (routeData.title) {
                    this.titleService.setTitle(`${routeData.title} :: eContador`)
                } else {
                    this.titleService.setTitle('eContador')
                }

                this.esconderLoading()
            })
    }

    ngOnDestroy() {
        this.routerUtils.removerEventoDeRouter()
    }

    private esconderLoading() {
        const loading = document.querySelector('div#router-loading')
        loading.setAttribute('hidden', '')
    }

    private inicializarMenu() {
        let operador: Operador
        this.operadorService.corrente.subscribe((op) => (operador = op))

        let bureau: Bureau
        this.bureauService.corrente.subscribe((b) => (bureau = b))

        menuUtils.adicionarNavbarElement(bureau.userConnection, operador)
        menuUtils.adicionarMenuElement(bureau.userConnection, operador)

        this.routerUtils = new RouterUtils(this.router)
        this.routerUtils.iniciarEventoDeRouter()
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts